module.exports = __webpack_public_path__ + "media/images/promo/black_friday_2019/part2-cdad1c5c8438e67be4671c760e8d77c1.png";